import 'react-app-polyfill/ie11';
import './polyfills';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

import App from './App';

//Doing "null" checks. Normally we wouldn't need to since we know it exists in our cshtml instance (such as we know 'root' exists), however, react gets upset.
var virtualViewToggle = document.getElementById('toggle-virtualView');
if (virtualViewToggle) {
    var viewid = virtualViewToggle.getAttribute('data-view');
    virtualViewToggle.onclick = function () {
        if (viewid) {
            var view = document.getElementById(viewid);
            if (view) {
                var loadedName = 'virtualView-loaded';
                if (!view.classList.contains(loadedName)) {
                    ReactDOM.render(<App />, document.getElementById('root'));
                    view.classList.add(loadedName);
                }
            }
        }
    };
}